<template>
  <div class="flex flex-col gap-2">
    <span v-if="label" class="px-1 text-sm text-gray-900" :class="labelClass">{{
      label
    }}</span>

    <label
      class="flex w-full gap-4 bg-white border border-[#E8E8E8] outline outline-1 outline-transparent rounded-2xl py-3 px-4"
      :class="{
        'h-[50px]': isInput,
        '!outline-[#7C7C7C]': input.isFocused && !isInvalid,
        '!outline-error': input.isFocused && isInvalid,
        '!border-error': isInvalid
      }"
    >
      <BaseIcon
        v-if="icon"
        :class="{
          'text-[#7C7C7C]': input.value,
          'text-[#D0D0D0]': !input.value
        }"
        :icon="icon"
      />

      <component
        :is="isTextarea ? 'textarea' : 'input'"
        ref="input"
        :type="type"
        :value="input.value"
        class="w-full text-gray-900 placeholder-[#D0D0D0] outline-none resize-none"
        :placeholder="placeholder"
        :rows="rows"
        @input="handleInput"
        @focus="handleFocus"
        @blur="handleBlur"
      />
    </label>

    <span v-if="isInvalid" class="ml-4 text-xs text-error">{{
      errors[0]
    }}</span>
  </div>
</template>

<script>
import BaseIcon from '@/components/Base/BaseIcon.vue'

export default {
  name: 'BaseInput',

  components: { BaseIcon },

  props: {
    label: { type: String, default: '' },
    labelClass: { type: String, default: '' },

    placeholder: { type: String, default: '' },
    value: { type: String, default: '' },
    type: { type: String, default: 'text' },
    icon: { type: String, default: '' },

    rows: { type: Number, default: 3 },

    errors: { type: Array, default: () => [] }
  },

  data: () => ({
    input: {
      value: '',
      isFocused: false
    }
  }),

  computed: {
    isInvalid() {
      return this.errors.length
    },

    isTextarea() {
      return this.type === 'textarea'
    },

    isInput() {
      return !this.isTextarea
    }
  },

  watch: {
    value: {
      immediate: true,
      handler(value, oldValue) {
        if (value === oldValue) return

        this.input.value = value

        if (this.$refs.input) {
          this.$refs.input.value = value
        }
      }
    }
  },

  methods: {
    handleInput(event) {
      const value = event.target.value.trim()

      this.$emit('input', value)
    },
    handleFocus() {
      this.input.isFocused = true
    },
    handleBlur() {
      this.input.isFocused = false
    }
  }
}
</script>
